import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

import { URL_API } from '../constante';
import {Question} from "./question";
import {Utils} from '../shared/utils';

@Injectable()
export class QuestionService {

  private headers = new Headers({'Accept': 'application/json; text/plain, */*'});
    private documentoUrl = URL_API + '/question/';

  getQuestions(edital: number): Promise<Question[]> {
    return this.http.get(this.documentoUrl + edital)
                .toPromise()
                .then(response => response.json() as Question[])
                .catch((error) => this.utils.handleError(error));
  }

  constructor(private http: Http, private utils: Utils) {}
}



// WEBPACK FOOTER //
// ./src/app/question/question.service.ts